/**
 * Cookies management library
 */

/**
 * Sets cookie
 * @param name
 * @param value
 * @param expires {Date}
 * @param path
 * @param domain
 * @param secure
 */
export function setCookie(name, value, expires, path, domain, secure) {
    document.cookie =
        name +
        '=' +
        encodeURIComponent(value) +
        (expires ? '; expires=' + expires.toGMTString() : '') +
        (path ? '; path=' + path : '') +
        (domain ? '; domain=' + domain : '') +
        (secure ? '; secure' : '');
}

/**
 * Gets cookie by it's name
 * @param name
 * @returns {string|undefined}
 */
export function getCookie(name) {
    let matches = document.cookie.match(
        new RegExp('(?:^|; )' + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)')
    );

    return matches ? decodeURIComponent(matches[1]) : undefined;
}

/**
 * Removes cookie by it's name
 * @param cookieName
 */
export function removeCookie(cookieName) {
    let cookieDate = new Date();
    cookieDate.setTime(cookieDate.getTime() - 1);
    document.cookie = cookieName += '=; expires=' + cookieDate.toGMTString();
}
